module.exports = __webpack_public_path__ + "static/media/question_active.4232ec15.svg";